import { Navigate, useLocation } from 'react-router-dom';

export default function ExpensesCreditPage() {
  const { search } = useLocation();
  return <Navigate to={`/transactions/credit${search}`} replace />;
}
